module.exports = __webpack_public_path__ + "static/media/ico.4b1b169b.svg";